/* =========================================================
   EYESHELLS: Split engo-scripts.js -> engo-sections.js
   - Home/Page section sliders (services/testimonials/collections/lookbook/etc.)
   - Loaded only where these sections can appear
   ========================================================= */

(function($){
  $(function(){
    "use strict";

    function testimonialV1() {
        $('.js-testimonial-v1').slick({
          autoplay: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          prevArrow: '<button class="testimonial-arrow arrow-prev"><i class="fa-solid fa-angle-left"></i></button>',
          nextArrow: '<button class="testimonial-arrow arrow-next"><i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    
    function testimonialV2() {
        $('.js-testimonial-v2-slide').slick({
          autoplay: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          dots: true,
          prevArrow: '<button class="testimonial-arrow arrow-prev"><i class="fa-solid fa-angle-left"></i></button>',
          nextArrow: '<button class="testimonial-arrow arrow-next"><i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    
    function servicev1(){
        $('.slickjs-services-v1').slick({
          dots: false,
          arrows:false,
          infinite: false,
          speed: 300,
          autoplay:false,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i></button>',
          nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 757,
              settings: {
                slidesToShow: 1,
                arrows:true,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                arrows:true,
              }
            }
          ]
        });
    
      }
    
    function servicev2(){
        $('.js-services-v2').slick({
          dots: false,
          arrows: false,
          infinite: false,
          speed: 300,
          autoplay:true,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i></button>',
          nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      }
    
    function brandv1() {
        $('.jsbrand_list_v1').slick({
          dots: false,
          arrows:false,
          speed: 300,
          slidesToShow: 5,
          slidesToScroll: 1,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i></button>',
          nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2
              }
            }
          ]
        });
      }
    
    function slidehome1(){
          var $slider = $('.js-slideshow-v1');
          if(!$slider.length){
            // Fallback for older markup
            $slider = $('.slick-side-h1');
          }
          if(!$slider.length) return;
    
          // Avoid double init
          if ($slider.hasClass('slick-initialized')) {
            try { $slider.slick('unslick'); } catch (e) {}
          }
    
          
    var autoplay = String($slider.data('autoplay')) === 'true';
    var autoplaySpeed = parseInt($slider.data('autoplay-speed'), 10);
    if (!autoplaySpeed || autoplaySpeed < 500) autoplaySpeed = 4500;
    var pauseOnHover = String($slider.data('pause-on-hover')) !== 'false';
    $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: autoplay,
            autoplaySpeed: autoplaySpeed,
            pauseOnHover: pauseOnHover,
            pauseOnFocus: true,
            dots: false,
            arrows: true,
            fade : true,
            speed: 420,
            adaptiveHeight: false,
            
            prevArrow:'<button type="button" class="prev-slide" aria-label="Previous slide"><i class="fa-solid fa-angle-left"></i></button>',
            nextArrow:'<button type="button" class="next-slide" aria-label="Next slide"><i class="fa-solid fa-angle-right"></i></button>',
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  dots: true,
                  arrows: false
                }
              }
            ]
          });
        }
    
    function slidehome2(){
        $('.slick-side-h2').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 3500,
          dots: false,
          arrows: true,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i> </button>',
          nextArrow:'<button type="button" class="next-slide"> <i class="fa-solid fa-angle-right"></i></button>',
          fade: true, 
          responsive: [
    
            {
              breakpoint: 1200,
              settings: {
                infinite: true,
                dots: false ,
                arrows: true
              }
            },
            {
              breakpoint: 1024,
              settings: {
                dots: false ,
                arrows: true
              }
            },
            {
              breakpoint:900,
              settings: {
                dots: true ,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 3500
              }
            }
          ]
        });
      }
    
    function slidehome3(){
        $('.slick-side-h3').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 3500,
          infinite: true,
          dots: false,
          arrows: true,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left" aria-hidden="true"></i></button>',
          nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right" aria-hidden="true"></i></button>',
          fade: false, 
          responsive: [
    
            {
              breakpoint: 1200,
              settings: {
                infinite: true,
                dots: false ,
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1024,
              settings: {
                dots: false ,
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                dots: false ,
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 600,
              settings: {
                dots: false ,
                arrows: true,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    
    function slidehome4(){
        $('.js-slideshow-v4').slick({
          dots: false,
          fade:true,
          arrows: true,
          speed: 300,
          autoplay: false,
          adaptiveHeight: true,
          prevArrow: '<button type="button" class="slideshow-arrow slick-slide-prev fa-solid fa-angle-left"></button>',
          nextArrow: '<button type="button" class="slideshow-arrow slick-slide-next fa-solid fa-angle-right"></button>',
          asNavFor: '.js-slideshow-thumb'
        });
        $('.js-slideshow-thumb').slick({
          slidesToShow: 1,
          slidesToScroll: 1,  
          fade:true,
          speed: 1000,
          asNavFor: '.js-slideshow-v4',
          dots: false,
          arrows: false,
          focusOnSelect: true
        });
    
        $('.js-slideshow-v4 .slider-info').eq(0).addClass('active')
        $('.js-slideshow-v4 .slider-img img').eq(0).addClass('active')
        $('.js-slideshow-thumb .banner-item img').eq(0).addClass('active')
        $('.js-slideshow-v4').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          var mySlideNumber = nextSlide;
          var prev = currentSlide;
          $('.js-slideshow-v4 .slider-info').eq(mySlideNumber).addClass('active');
          $('.js-slideshow-v4 .slider-img img').eq(mySlideNumber).addClass('active');
          $('.js-slideshow-thumb .banner-item img').eq(mySlideNumber).addClass('active');
          $('.js-slideshow-v4 .slider-info').eq(prev).removeClass('active');
          $('.js-slideshow-v4 .slider-img img').eq(prev).removeClass('active');
          $('.js-slideshow-thumb .banner-item img').eq(prev).removeClass('active');
        })
      }
    
    function slidehome5(){
        $('.slick-side-h5').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 3500,
          dots: true,
          arrows: true,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left" aria-hidden="true"></i></button>',
          nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right" aria-hidden="true"></i></button>',
          fade: true, 
          responsive: [
    
            {
              breakpoint: 1200,
              settings: {
                infinite: true,
                dots: true ,
                arrows: false
              }
            },
            {
              breakpoint: 1024,
              settings: {
                dots: true ,
                arrows: false
              }
            },
            {
              breakpoint:600,
              settings: {
                dots: true ,
                arrows: false,
                autoplay: true,
              }
            }
          ]
        });
      }
    
    function Collectionv1() {
        $('.js-collection-v1').slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          autoplay: false,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i> </button>',
          nextArrow:'<button type="button" class="next-slide"> <i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1500,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrow: false,
                dots: false
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: false
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: false
              }
            },
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                autoplay: true
              }
            }
          ]
        });
      }
    
    function Collectionv2() {
        $('.js-collection-v2').slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          autoplay: false,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i> </button>',
          nextArrow:'<button type="button" class="next-slide"> <i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1500,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrow: false,
                dots: true
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
                dots: true
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: true
              }
            },
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                autoplay: true
              }
            }
          ]
        });
      }
    
    function Collectionv3() {
        $('.js-collection-v3').slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          autoplay: false,
          centerMode: true,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i> </button>',
          nextArrow:'<button type="button" class="next-slide"> <i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1500,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    
    function Blogv1(){
        $('.js-blog-v1').slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true,
          arrows: false,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i> </button>',
          nextArrow:'<button type="button" class="next-slide"> <i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1500,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrow: false,
                dots: false
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
                dots: false
              }
            },
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: false
              }
            }
          ]
        });
      }
    
    function Blogv2(){
        $('.js-blog-v2').slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true,
          arrows: true,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i> </button>',
          nextArrow:'<button type="button" class="next-slide"> <i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: false
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false
              }
            }
          ]
        });
      }
    
    function product_v1() { 
        $('.js_section_product').slick({
          slidesToShow: 4,
          slidesToScroll: 2,
          speed: 900,
          autoplay: false,
          autoplaySpeed: 3500,
          dots: true,
          arrows: false,
          prevArrow:'<button type="button" class="prev-slide slick-arrow"><i class="fa-solid fa-angle-left"></i> </button>',
          nextArrow:'<button type="button" class="next-slide slick-arrow"><i class="fa-solid fa-angle-right"></i></button>', 
          responsive: [
            {
              breakpoint:920,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint:768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
              }
            }
          ]
        });
      }
    
    function productV5() {
        $('.js_product_v5').slick({
          dots: false,
          arrows: false,
          infinite: true,
          speed: 300,
          autoplay: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow:'<button type="button" class="prev-slide"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 443.52 443.52" style="enable-background:new 0 0 443.52 443.52;" xml:space="preserve"> <g> <g> <path d="M143.492,221.863L336.226,29.129c6.663-6.664,6.663-17.468,0-24.132c-6.665-6.662-17.468-6.662-24.132,0l-204.8,204.8 c-6.662,6.664-6.662,17.468,0,24.132l204.8,204.8c6.78,6.548,17.584,6.36,24.132-0.42c6.387-6.614,6.387-17.099,0-23.712 L143.492,221.863z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
          nextArrow:'<button type="button" class="next-slide"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <g> <g> <path d="M390.965,241.681l-242.001-236c-7.907-7.711-20.57-7.553-28.282,0.355c-7.712,7.908-7.553,20.57,0.355,28.282L348.353,256 L121.037,477.681c-7.908,7.712-8.067,20.374-0.355,28.282c7.713,7.91,20.375,8.065,28.281,0.355l242.001-236 C394.823,266.555,397,261.391,397,256S394.823,245.445,390.965,241.681z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>', 
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
    
      }
    
    function productV6(){
        $('.js_product_v6').slick({
          dots: true,
          arrows:false,
          infinite: false,
          speed: 300,
          autoplay:true,
          slidesToShow: 2,
          slidesToScroll: 1,
          prevArrow:'<button type="button" class="prev-slide"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 443.52 443.52" style="enable-background:new 0 0 443.52 443.52;" xml:space="preserve"> <g> <g> <path d="M143.492,221.863L336.226,29.129c6.663-6.664,6.663-17.468,0-24.132c-6.665-6.662-17.468-6.662-24.132,0l-204.8,204.8 c-6.662,6.664-6.662,17.468,0,24.132l204.8,204.8c6.78,6.548,17.584,6.36,24.132-0.42c6.387-6.614,6.387-17.099,0-23.712 L143.492,221.863z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
          nextArrow:'<button type="button" class="next-slide"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <g> <g> <path d="M390.965,241.681l-242.001-236c-7.907-7.711-20.57-7.553-28.282,0.355c-7.712,7.908-7.553,20.57,0.355,28.282L348.353,256 L121.037,477.681c-7.908,7.712-8.067,20.374-0.355,28.282c7.713,7.91,20.375,8.065,28.281,0.355l242.001-236 C394.823,266.555,397,261.391,397,256S394.823,245.445,390.965,241.681z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>', 
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
    
      }
    
    function jsbannerv1(){
        $('.js_banner_v1').slick({
          dots: false,
          arrows: false,
          infinite: true,
          speed: 600,
          autoplay:false,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i></button>',
          nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    
    function js_product_flashsale(){
        $('.slick_product_5').slick({
          arrows: false,
          infinite: true,
          dots: true ,
          speed: 300,
          slidesToShow: 4,
          slidesToScroll: 3,
          autoplay: true,
          autoplaySpeed: 2000,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left" aria-hidden="true"></i></button>',
          nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right" aria-hidden="true"></i></button>', 
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: false,
                arrows : true
              }
            }
          ]
        });
      }
    
    function jsslidelookbook(){
        $('.js_slide_lookbook').slick({
          dots: false,
          arrows:false,
          infinite: false,
          speed: 300,
          autoplay:false,
          slidesToShow: 1,
          slidesToScroll: 1
        });
    
      }

    function runIf(sel, fn){ if ($(sel).length) { try { fn(); } catch(e) { /* ignore */ } } }
    runIf('.js-testimonial-v1', testimonialV1);
    runIf('.js-testimonial-v2', testimonialV2);
    runIf('.slickjs-services-v1', servicev1);
    runIf('.js-services-v2', servicev2);
    runIf('.jsbrand_list_v1', brandv1);
    runIf('.js-slideshow-v1', slidehome1);
    runIf('.slick-side-h2', slidehome2);
    runIf('.slick-side-h3', slidehome3);
    runIf('.js-slideshow-v4', slidehome4);
    runIf('.slick-side-h5', slidehome5);
    runIf('.js-collection-v1', Collectionv1);
    runIf('.js-collection-v2', Collectionv2);
    runIf('.js-collection-v3', Collectionv3);
    runIf('.js-blog-v1', Blogv1);
    runIf('.js-blog-v2', Blogv2);
    runIf('.js_section_product', product_v1);
    runIf('.js_product_v5', productV5);
    runIf('.js_product_v6', productV6);
    runIf('.js_banner_v1', jsbannerv1);
    runIf('.slick_product_5', js_product_flashsale);
    runIf('.js_slide_lookbook', jsslidelookbook);
  });
})(window.jQuery);
